import { Fachrichtung } from '@ps-gui/shared-core';
import { FieldGroupModel } from '../../models/extraction-models/extraction-models';
import { FieldType } from '@ps-gui/shared-utils';

export const ErfassungBehandlerSections: FieldGroupModel[] = [
  {
    key: 'behandler_fields',
    label: 'Behandler',
    icon: '@shared-core/icons/user-doctor-regular-full.svg',
    index: 0,
    fieldModels: [
      {
        key: 'einrichtung',
        label: {
          text: 'Einrichtung',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 1,
      },
      {
        key: 'fachgebiet',
        label: {
          text: 'Fachgebiet',
          genus: 'N',
        },
        type: FieldType.DROPDOWN,
        options: ['Unbekannt', ...Object.values(Fachrichtung)].map((value) => ({
          value,
          label: value,
        })),
        defaultValue: {
          value: 'Unbekannt',
          label: 'Unbekannt',
        },
        index: 2,
      },
      {
        key: 'titel',
        label: {
          text: 'Titel',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 4,
      },
      {
        key: 'vorname',
        label: {
          text: 'Vorname',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 5,
      },
      {
        key: 'nachname',
        label: {
          text: 'Nachname',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 6,
      },
    ],
    type: 'fieldGroupModel',
  },
  {
    key: 'contact_fields',
    label: 'Kontakt',
    icon: '@shared-core/icons/phone-regular-full.svg',
    index: 7,
    fieldModels: [
      {
        key: 'telefon',
        label: {
          text: 'Telefon',
          genus: 'N',
        },
        type: FieldType.STRING,
        index: 8,
      },
      {
        key: 'fax',
        label: {
          text: 'Fax',
          genus: 'N',
        },
        type: FieldType.STRING,
        index: 9,
      },
      {
        key: 'email',
        label: {
          text: 'E-Mail',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 10,
      },
    ],
    type: 'fieldGroupModel',
  },
];
